// import React, { useEffect, useState } from 'react'
// import { Skeleton } from 'antd'
// import axios from 'axios'
// import { Link } from 'react-router-dom'
// import { GET } from '../../utils/apis'
// import EnglishLanguage from '../../Languages/EnglishLanguage.json'
// import NlLanguage from '../../Languages/NetherlandsLanguage.json'
// import { useSelector } from 'react-redux'

// const VerifyEmail = (props) => {
//     const { language, selectedLanguage } = props
//     const isEnglish = language?.language === 'english'
//     const [state, setState] = useState({
//         verify: false,
//         message: '',
//         success: false
//     })

//     const updateState = (obj) => {
//         setState({ ...state, ...obj })
//     }
// console.log('props',props)
//     useEffect(() => {
//         const { match } = props
//         const { token } = match?.params
//         axios.get(`${GET.VERIFY_EMAIL}/${token}`)
//             .then((result) => {
//                 const { data } = result
//                 if (data.success) {
//                     updateState({ message: isEnglish ? data.message : data.messageNl, success: data.success })
//                 }
//                 else {
//                     updateState({ message: isEnglish ? data.message : data.messageNl, success: data.success })
//                 }
//             })
//             .catch(e => {
//                 updateState({ message: selectedLanguage?.backendMsg_SomethingWentWrongPleaseRefreshThisPage, success: false })
//             })
//     }, [])

//     return (
//         <div className='verify-div'>
//             {state.message.length ? <div className='verify-child'>
//                 <p className='verify-head'>{selectedLanguage?.title_EmailVerification}</p>
//                 <p className='verify-text'>{state.message}</p>
//                 {state.success && <p className='verify-text'>{selectedLanguage?.title_NowYouCan} <Link className='linkStyle' to='/'>{selectedLanguage?.minTitle_Login}</Link>.</p>}
//             </div> : <Skeleton paragraph={{ rows: 22 }} />}
//         </div>
//     )
// }

// export default VerifyEmail









import React, { useEffect, useState } from 'react'
import { Skeleton } from 'antd'
import axios from 'axios'
import { Link } from 'react-router-dom'
import { GET } from '../../utils/apis'

const VerifyEmail = (props) => {
    const { language, selectedLanguage, match } = props

    const isEnglish = language?.language === 'english'

    const [state, setState] = useState({
        message: '',
        success: false,
        loading: true
    })

    useEffect(() => {
        const token = match?.params?.token

        console.log('Verify Email Token:', token)

        if (!token) {
            setState({
                message: selectedLanguage?.backendMsg_SomethingWentWrongPleaseRefreshThisPage || 'Verification token not found',
                success: false,
                loading: false
            })
            return
        }

        axios
            .get(`${GET.VERIFY_EMAIL}/${token}`)
            .then((result) => {
                const { data } = result

                setState({
                    message: isEnglish ? data?.message : data?.messageNl,
                    success: data?.success,
                    loading: false
                })
            })
            .catch((error) => {
                console.log('Verify Email Error:', error)

                setState({
                    message: selectedLanguage?.backendMsg_SomethingWentWrongPleaseRefreshThisPage || 'Something went wrong. Please refresh this page.',
                    success: false,
                    loading: false
                })
            })
    }, [
        match?.params?.token,
        isEnglish,
        selectedLanguage?.backendMsg_SomethingWentWrongPleaseRefreshThisPage
    ])

    return (
        <div className='verify-div'>
            {state.loading ? (
                <Skeleton paragraph={{ rows: 22 }} />
            ) : (
                <div className='verify-child'>
                    <p className='verify-head'>
                        {selectedLanguage?.title_EmailVerification || 'Email Verification'}
                    </p>

                    <p className='verify-text'>
                        {state.message}
                    </p>

                    {state.success && (
                        <p className='verify-text'>
                            {selectedLanguage?.title_NowYouCan || 'Now you can'}{' '}
                            <Link className='linkStyle' to='/'>
                                {selectedLanguage?.minTitle_Login || 'Login'}
                            </Link>.
                        </p>
                    )}
                </div>
            )}
        </div>
    )
}

export default VerifyEmail